import styles from "./NoSearchResults.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import ModalColumn from "../../ModalColumn/ModalColumn";

type NoSearchResultsProps = {
  searchQuery: string;
  searchTarget: string;
  onSearchForClick: () => void;
  clearSearch: () => void;
};

export const NoSearchResults = (props: NoSearchResultsProps) => {
  const { t } = useTranslation();
  return (
    <ModalColumn gap="big">
      <div className={styles["textWrapper"]}>
        <FixaText textStyle="Heading.M">
          {t("noResultsForString", { query: props.searchQuery })}
        </FixaText>
        <FixaText textStyle="Heading.M">
          {t("trySearchingInString", { value: props.searchTarget })}
        </FixaText>
      </div>
      <ModalColumn gap="small">
        <FixaButton
          type="primary"
          text={t("searchForString", { value: props.searchTarget })}
          size="small"
          fluid
          onClick={props.onSearchForClick}
        />
        <FixaButton
          type="secondary"
          text={t("clearSearchString")}
          size="small"
          fluid
          onClick={props.clearSearch}
        />
      </ModalColumn>
    </ModalColumn>
  );
};
